function closeMenus() {
    $('[data-menu]').removeClass('active');
    $("[data-opens-menu]").removeClass("active");
    $('[data-hide-mobile-menu]').hide();
    $('[data-show-mobile-menu]').show();
}

function showMobileSearch() {
    closeMenus();

    //hide menu links
    $('.header-2024-mobile-menu-icons').hide();

    //hide search icon
    $('.header-2024-mobile-search-icon-container').hide();

    //show search close icon
    $('.header-2024-mobile-search-close-icon').show();

    //show search     
    $('.header-2024-mobile-search').addClass("active");

    //add header-menu-opened from body
    $('body').addClass('header-menu-opened');
}

window.hideMobileSearch = function () {
    //hide search
    $('.header-2024-mobile-search').removeClass("active");

    //hide close search icon
    $('.header-2024-mobile-search-close-icon').hide();

    //show search icon
    $('.header-2024-mobile-search-icon-container').show();

    //show menu icons
    $('.header-2024-mobile-menu-icons').show();

    $('[data-open-mobile-menu]').show();

    //remove header-menu-opened to body
    $('body').removeClass('header-menu-opened');
}

function showMobileMenu() {
    //close the search
    hideMobileSearch();

    $('[data-open-mobile-menu]').hide();
    $('[data-hide-mobile-menu]').show();
    $('.header-2024-main').addClass('active');

    //add header-menu-opened to body
    $('body').addClass('header-menu-opened');
}

function hideMobileMenu() {
    $('[data-hide-mobile-menu]').hide();
    $('[data-open-mobile-menu]').show();
    $('.header-2024-main').removeClass('active');
    $('.header-2024-main-dropdown-link').removeClass('active');
    $('.header-2024-main-dropdown-container').removeClass('active');
    //remove header-menu-opened to body
    $('body').removeClass('header-menu-opened');
}

//close the dropdown menu when clicking outside it (but also not the activatable link)
$(document).click(function (event) {
    var $activeMenus = $('.header-2024-main-dropdown-container.active').length;
    if ($activeMenus) {
        var $target = $(event.target);
        var attr = $target[0].hasAttribute('data-opens-menu');
        //if the current target isn't the menu itself, isn't the button that activates the menu, and isn't a child of the button that activates it
        if (!attr && !$target.closest('.header-2024-main-dropdown-container').length && !$target.closest(".header-2024-mobile").length && !$target.closest('[data-opens-menu]').length) {
            //hide the menu
            hideMobileMenu();
        }
    }
});

$('[data-show-search]').on('click', function () {
    showMobileSearch();
});

$('[data-hide-search]').on('click', function () {
    hideMobileSearch();
});

$('[data-open-mobile-menu]').on('click', function () {
    showMobileMenu();
});

$('[data-hide-mobile-menu]').on('click', function () {
    hideMobileMenu();
});

function closeDropdownMenu(elem) {
    //get the menu id 
    var dropdownMenuContainer = $(elem).closest('.header-2024-main-dropdown-container');
    //find your parent and remove your active class
    dropdownMenuContainer.removeClass('active');
    //find your parent's siblign and remove their active class
    $("[data-opens-menu='" + $(dropdownMenuContainer).attr('data-menu') + "']").removeClass("active");
}

$('[data-dropdownmenu-close]').on('click', function () {
    closeDropdownMenu($(this));
});

$('[data-opens-menu]').on('click', function () {
    var target = $(this).attr('data-opens-menu');
    if (target.length) {
        $(this).toggleClass('active');
        $("[data-menu='" + target + "']").toggleClass("active");

        //is opened
        if ($(this).hasClass('active')) {
            $('body').addClass('header-menu-opened');
            showMobileMenu();
        }
        //is closed
        else {
            $('body').removeClass('header-menu-opened');
            hideMobileMenu();
        }
    }
});

$('[data-menu-open]').on('click', function () {
    $('.header-2024-main').toggleClass('active');
    $(this).hide();
    $('[data-menu-close]').show();

    if ($('.header-2024-main').hasClass('active')) {
        $('.header-2024-main-dropdown-link').removeClass('active');
        $('body').addClass('header-menu-opened');
    }
    else {
        $('body').removeClass('header-menu-opened');
    }
});

function clearInput(elem) {
    $(elem).val('').trigger('input');
}

$('[data-clear-input]').on('click', function () {
    clearInput($(this).attr('data-clear-input'));
});

//offsets component anchors to compensate for current height of the header and in page navigation
window.offsetHeaderInPageNavigationAnchors = function () {

    var headerElement = $('#header');
    var anchorOffset;

    if (headerElement === null || headerElement.length <= 0) {
        headerElement = $('.header-sticky-container');
    }

    if (headerElement.length) {
        anchorOffset = $(headerElement).outerHeight() + 1;
    }

    if (anchorOffset) {
        $('[data-scroll-margin-top]').css("scroll-margin-top", anchorOffset);
        $('[id]').css("scroll-margin-top", anchorOffset);
    }

    $('.sticky-element').each(function () {
        let offset = anchorOffset;

        if ($(this).hasAttr('data-sticky-element-extra-top')) {
            offset += parseFloat($(this).attr('data-sticky-element-extra-top')) || 0;
        }

        $(this).css("top", offset);
    });
}

$(window).on('load', function () {
    offsetHeaderInPageNavigationAnchors();
    if ($('.services-directory').length > 0) {
        setupServicesDirectoryActiveHighlighting();
    }
});

$(window).on('resize', throttle(function () {
    offsetHeaderInPageNavigationAnchors();
}, 400));

var lastScrollTop = 0;
var $localNav = $('.baptist-2025-local-navigation-mobile');
var $mobileHeader = $('.header-2024-mobile');

// Track the last scroll position globally
var lastScrollTop = 0;

// Cache DOM references for performance
var $localNav = $('.baptist-2025-local-navigation-mobile');
var $mobileHeader = $('.header-2024-mobile');

/**
 * Determines the scroll direction.
 * Special handling for iOS bounce behavior:
 *   - On iOS, when the user pulls down at the top of the page (scroll bounce),
 *     `scrollTop` may return 0 even though the user is still in motion.
 *   - To ensure the header becomes visible again in this edge case,
 *     we explicitly return 'top' when scrollTop is at or below 0.
 */
function checkScrollDirection() {
    var scrollTop = $(window).scrollTop();
    var direction = '';

    if (scrollTop <= 0) {
        // User is at the very top of the page (or bounce-scrolling)
        direction = 'top';
    } else if (scrollTop > lastScrollTop) {
        // User scrolled down
        direction = 'down';
    } else if (scrollTop < lastScrollTop) {
        // User scrolled up
        direction = 'up';
    }

    // Prevent negative values due to bounce or unexpected values
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;

    return direction;
}

/**
 * Applies a translateY transform to hide or reveal the mobile header
 * and local navigation based on the detected scroll direction.
 */
function hideMobileNavigation() {
    var direction = checkScrollDirection();
    var mobileHeaderHeight = $mobileHeader.outerHeight();

    if (direction === 'down') {
        // Scroll down: hide the header and nav by translating them out of view
        $mobileHeader.css('transform', 'translateY(-' + mobileHeaderHeight + 'px)');
        $localNav.css('transform', 'translateY(-' + mobileHeaderHeight + 'px)');
    } else if (direction === 'up' || direction === 'top') {
        // Scroll up or bounce to top: reveal the header and nav
        // 'top' ensures visibility when user pulls down past the top (iOS-specific fix)
        $mobileHeader.css('transform', '');
        $localNav.css('transform', '');
    }
}

/**
 * On DOM ready, attach scroll event handler and apply the scroll effect once
 * to set the initial header state.
 */
$(document).ready(function () {
    if ($localNav.length) {
        // Initial check in case the user loads the page mid-scroll
        hideMobileNavigation();

        // Use a throttled scroll handler to avoid performance issues
        var throttledApplyScrollEffect = window.throttle(hideMobileNavigation, 100);
        $(window).on('scroll', throttledApplyScrollEffect);
    }
});


function setupServicesDirectoryActiveHighlighting() {
    // Grab the first visible section to compute sticky header offset
    const $firstSection = $('.services-directory-alphabet-letter-section-container').first();
    let stickyOffset = parseFloat($firstSection.css('scroll-margin-top')) || 0;

    const $sections = $('.services-directory-alphabet-letter-section-container');
    const $navLinks = $('.services-directory-navigation-letter-link');

    // This function marks nav letters as 'disabled' if their section is hidden
    function updateDisabledLetters() {
        $navLinks.each(function () {
            const targetId = this.getAttribute('href')?.slice(1); // get ID target from href
            const $targetSection = $('#' + targetId);

            // Only keep enabled if corresponding section is visible
            if ($targetSection.length && $targetSection.is(':visible')) {
                $(this).removeClass('disabled');
            } else {
                $(this).addClass('disabled').removeClass('active'); // also clear 'active' just in case
            }
        });
    }

    // This function determines which letter should be highlighted
    function updateActiveLetter() {
        const scrollTop = $(window).scrollTop();
        const firstOffset = $sections.first().offset().top;

        // Special case: user scrolled above the first section
        // Force "A" to be active (if not hidden/disabled)
        if (scrollTop + stickyOffset < firstOffset) {
            $navLinks.removeClass('active');
            $navLinks.each(function () {
                if (this.getAttribute('href').endsWith('-link-A')) {
                    $(this).addClass('active');
                }
            });
            return;
        }

        let currentSection = null;

        // Loop through visible sections and find the one closest to the sticky point
        $sections.filter(':visible').each(function () {
            const offset = $(this).offset().top;
            if (offset - scrollTop <= stickyOffset) {
                currentSection = this;
            }
        });

        // Fallback: If nothing matched above, just use the first visible section
        let finalSection = currentSection || $sections.filter(':visible').first()[0];

        if (finalSection) {
            const sectionId = finalSection.id;

            $navLinks.removeClass('active'); // clear current highlight

            // Re-apply highlight to matching nav letter, if not disabled
            $navLinks.each(function () {
                if (
                    this.getAttribute('href').slice(1) === sectionId &&
                    !$(this).hasClass('disabled')
                ) {
                    $(this).addClass('active');
                }
            });
        }

        // Update which nav letters are considered 'disabled'
        updateDisabledLetters();
    }

    // Throttle scroll event to limit frequency of updates
    const throttledUpdate = throttle(updateActiveLetter, 400);

    // Bind scroll event
    $(window).on('scroll', throttledUpdate);

    // Run on initial load in case content is already in view
    updateActiveLetter();

    // Make functions accessible globally (so search script can call them)
    window.updateDisabledLetters = updateDisabledLetters;
    window.updateActiveLetter = updateActiveLetter;
}

